<template>
  <div class="w-full h-full static-css">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'public-home',
  mounted: function () {
    if (!document.body.classList.contains('static-css')) {
      document.body.classList.add('static-css')
    }
  },
}
</script>
